import api from './api'

/**
 * Basketball API Service
 * Spezifische API-Funktionen für Basketball-Template-Integration
 * Verwendet nur die tatsächlich vorhandenen Backend-Routen
 */

// ==================== BASKETBALL API SETTINGS ====================

/**
 * Basketball API-Einstellungen für Team-Template speichern
 * Verwendet: PUT /teams/templates/{teamTemplateId}/api-settings
 * @param {string} teamTemplateId - ID des Team-Templates
 * @param {Object} apiSettings - API-Einstellungen
 * @param {string} apiSettings.clubId - Club ID
 * @returns {Promise<Object>} API-Response
 */
export const saveBasketballApiSettings = async (teamTemplateId, apiSettings) => {
  try {
    const response = await api.put(`/teams/templates/${teamTemplateId}/api-settings`, {
      apiSettings
    })
    return {
      success: true,
      data: response.data,
      message: 'Basketball API-Einstellungen erfolgreich gespeichert'
    }
  } catch (error) {
    console.error('Error saving basketball API settings:', error)
    return {
      success: false,
      error: error.response?.data?.error || error.message || 'Fehler beim Speichern der API-Einstellungen'
    }
  }
}

/**
 * Basketball API-Daten für Team-Template abrufen
 * Verwendet: GET /teams/templates/{teamTemplateId}/fetch-api-data
 * @param {string} teamTemplateId - ID des Team-Templates
 * @returns {Promise<Object>} API-Response mit Daten
 */
export const fetchBasketballApiData = async (teamTemplateId) => {
  try {
    const response = await api.get(`/teams/templates/${teamTemplateId}/fetch-api-data`)
    return {
      success: response.data.success,
      data: response.data.data,
      message: response.data.message
    }
  } catch (error) {
    console.error('Error fetching basketball API data:', error)
    return {
      success: false,
      error: error.response?.data?.error || error.message || 'Fehler beim Abrufen der API-Daten'
    }
  }
}

// ==================== TEAM TEMPLATE DRAFTS ====================

/**
 * Alle Team-Template-Drafts für ein Team-Template abrufen
 * Verwendet: GET /team-template-drafts/{teamTemplateId}/drafts
 * @param {string} teamTemplateId - ID des Team-Templates
 * @param {Object} params - Query-Parameter (page, limit, search, etc.)
 * @returns {Promise<Object>} Paginierte Liste der Drafts
 */
export const getTeamTemplateDrafts = async (teamTemplateId, params = {}) => {
  try {
    const response = await api.get(`/team-template-drafts/${teamTemplateId}/drafts`, { params })
    return {
      success: true,
      data: response.data,
      message: 'Bereich-Template-Drafts erfolgreich abgerufen'
    }
  } catch (error) {
    console.error('Error fetching team template drafts:', error)
    return {
      success: false,
      error: error.response?.data?.error || error.message || 'Fehler beim Abrufen der Template-Drafts'
    }
  }
}

export default {
  // Basketball API Settings
  saveBasketballApiSettings,
  fetchBasketballApiData,
  
  // Team Template Drafts
  getTeamTemplateDrafts
}
